import { Stack } from '@treatwell/ui';
import React from 'react';
import {
  VenueCardSection,
  VenueCardSectionType,
} from '../VenueCardSection/VenueCardSection';
import styles from './VenueCardList.module.css';

export type VenueCardListType = VenueCardSectionType[];

export const VenueCardList = ({
  venueCardSections,
  countryCode,
}: {
  venueCardSections: VenueCardListType;
  countryCode: string;
}) => (
  <Stack space="xl">
    {venueCardSections.map((venueCardSection, index) => (
      <React.Fragment key={index}>
        <VenueCardSection
          className={styles.list}
          {...venueCardSection}
          countryCode={countryCode}
        />
      </React.Fragment>
    ))}
  </Stack>
);
